export const buildTabId = (prefix: string, id: string): string => `${prefix}-tab-${id}`;

export const buildTabPanelId = (prefix: string, id: string): string =>
  `${prefix}-panel-${id}`;
